import React from 'react';
import { FieldValues } from 'react-hook-form';
import { EntityFormContext } from '../contexts';
import { EntityFormContextType } from '../types';

export const useEntityFormContext = <TFieldValues extends FieldValues>(): EntityFormContextType<TFieldValues> =>
  React.useContext(EntityFormContext) as unknown as EntityFormContextType<TFieldValues>;
